import type {Content} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import {useLinkResolver} from 'prismicio'
import {DEFAULT_PADDING, PADDING_BOTTOM_CLASS, PADDING_TOP_CLASS} from 'src/common/paddingClasses'
import type {Context} from 'src/common/types'
import {InfoBanner as InfoBannerUI} from './InfoBanner'

export type InfoBannerProps = SliceComponentProps<Content.InfoBannerSlice>

const InfoBanner = ({
  slice,
  context: {pageUid},
  index: componentIndex,
}: InfoBannerProps & {context: Context}): JSX.Element | null => {
  const {linkResolver} = useLinkResolver()

  switch (slice.variation) {
    case 'default': {
      const buttonHref = isFilled.link(slice.primary.button_link)
        ? linkResolver(slice.primary.button_link, `component-${componentIndex}-info-banner`)
        : undefined

      return (
        <InfoBannerUI
          sliceType={slice.slice_type}
          sliceVariation={slice.variation}
          paddingTopClass={PADDING_TOP_CLASS[slice.primary.padding_top ?? DEFAULT_PADDING] ?? ''}
          paddingBottomClass={PADDING_BOTTOM_CLASS[slice.primary.padding_bottom ?? DEFAULT_PADDING] ?? ''}
          title={isFilled.keyText(slice.primary.title) ? slice.primary.title : ''}
          badges={slice.primary.badges
            .filter((badge) => isFilled.keyText(badge.label))
            .map((badge) => ({label: badge.label as string}))}
          description={isFilled.keyText(slice.primary.description) ? slice.primary.description : ''}
          buttonLabel={isFilled.keyText(slice.primary.button_label) ? slice.primary.button_label : ''}
          buttonHref={buttonHref}
          buttonTarget={
            isFilled.link(slice.primary.button_link) &&
            slice.primary.button_link.link_type === 'Web' &&
            slice.primary.button_link.target
              ? slice.primary.button_link.target
              : undefined
          }
          buttonMarketingId=""
          pageUid={pageUid ?? ''}
        />
      )
    }

    default:
      return null
  }
}

export default InfoBanner
